<template>
<div class="chapter">
<div class="inner_page">
<div class="frontMatter">
<a id="title2"></a><div class="title-frontMatter">
<div class="p"><span>Dear Reader,</span></div>
<div class="p-blanc"><span> <br/></span></div>
<div class="p"><span>A sexy fire fighter, a crazy cat and a dynamite heroine—that’s what you’ll find in <em class="i">Lucy and the Loner</em>, Elizabeth Bevarly’s wonderful MAN OF THE MONTH. It’s the next in her installment of THE FAMILY McCORMICK series, and it’s also a MAN OF THE MONTH book you’ll never forget—warm, humorous and very sexy!</span></div>
<div class="p-blanc"><span> <br/></span></div>
<div class="p"><span>A story from Lass Small is always a delight, and <em class="i">Chancy’s Cowboy</em> is Lass at her most marvelous. Don’t miss out as Chancy decides to take some lessons in love from a handsome hunk of a cowboy!</span></div>
<div class="p-blanc"><span> <br/></span></div>
<div class="p"><span>Eileen Wilks’s latest, <em class="i">The Wrong Wife</em>, is chock-full with the sizzling tension and compelling reading that you’ve come to expect from this rising Desire star. And so many of you know and love Barbara McCauley that she needs no introduction, but this month’s <em class="i">The Nanny and the Reluctant Rancher</em> is sure to both please her current fans...and win her new readers!</span></div>
<div class="p-blanc"><span> <br/></span></div>
<div class="p"><span>Suzannah Davis is another new author that we’re excited about, and <em class="i">Dr</em>. <em class="i">Holt and the Texan</em> may just be her best book to date! And the month is completed with a delightful. romp from Susan Carroll, <em class="i">Parker and the Gypsy</em>.</span></div>
<div class="p-blanc"><span> <br/></span></div>
<div class="p"><span>There’s something for everyone. So come and relish the romantic variety you’ve come to expect from Silhouette Desire!</span></div>
<div class="illustype_image_text"><div class="image_text"><img alt="9781459271517_i0002.jpg" src="9781459271517_i0002.jpg"/></div></div>
<div class="p-br"><span>Lucia Macro <br/>And the Editors at Silhouette Desire</span></div>
<br/><div class="box"><div class="p-br-box"><span>Please address questions and book requests to: <br/>Silhouette Reader Service <br/>U.S.: 3010 Walden Ave., P.O. Box 1325, Buffalo, NY 14269 <br/>Canadian: P.O. Box 609, Fort Erie, Ont L2A 5X3</span></div></div><br/></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781459271517_fm02.vue?1bdc7b8a